import { render } from "./AppSnackbar.vue?vue&type=template&id=680c0083&scoped=true"
import script from "./AppSnackbar.vue?vue&type=script&lang=js"
export * from "./AppSnackbar.vue?vue&type=script&lang=js"

import "./AppSnackbar.vue?vue&type=style&index=0&id=680c0083&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680c0083"]])

export default __exports__